const AuthProvider = ({ children }: { children: ReactNode }) => {
  // const token = useMemo(() => localStorage.getItem("token"), [])

  console.log("auth provider")
  // useEffect(() => {
  //   if (data?.authenticateToken) dispatch(loginState((data?.authenticateToken ?? {}) as AuthResponseDto))
  // }, [data])

  return children
}
export default AuthProvider
